module.exports = __webpack_public_path__ + "static/media/ico-colored-microphone.62f8cd6a.svg";